<template>
  <div style="height: 100%">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="列表" name="list">
        <el-form :inline="true" label-width="68px" class="searchListInput">
          <el-form-item label="用户账号">
            <el-input
              v-model="userCode"
              size="small"
              style="width: 150px"
              disabled
            />
          </el-form-item>
          <el-form-item class="mb8">
            <el-button
              type="primary"
              icon="el-icon-finished"
              size="mini"
              @click="save"
              >保存
            </el-button>
            <el-button
              type="primary"
              icon="el-icon-refresh-right"
              size="mini"
              @click="handleQuery"
              >刷新
            </el-button>
          </el-form-item>
        </el-form>

          <el-input
            placeholder="输入关键字进行过滤"
            v-model="filterText"
            size="small"
          >
          </el-input>
        <el-scrollbar style="height: 98%">
          <el-tree
            v-loading="loading"
            id="treeMenu"
            ref="treeMenu"
            :data="treeData"
            :filter-node-method="filterNode"
            class="filter-tree"
            node-key="key"
            :default-expand-all="true"
            :check-on-click-node="true"
            :show-checkbox="true"
            :default-checked-keys="defaultCheckedKeys"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span v-if="data.children" class="el-icon-user"> </span>
              <span
                v-else
                class="el-icon-monitor"
                style="margin-right: 3px"
              ></span>
              <span>{{ node.label }}</span>
            </span>
          </el-tree>
        </el-scrollbar>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { selectList, add } from '../../api/system/userModule';

export default {
  name: 'Spring',
  data() {
    return {
      userCode: '',
      userId: '',
      activeTab: 'list',
      // 遮罩层
      loading: true,
      treeNodeFontColor: '',
      filterText: '',
      treeData: [],
      defaultCheckedKeys: [],
    };
  },

  watch: {
    $route(to) {
      const path = String(to.path);
      if (path.endsWith('userModule')) {
        if (this.$route.query.userId == undefined) return;
        this.userId = this.$route.query.userId;
        this.handleQuery();
      }
    },
    filterText(val) {
      this.$refs.treeMenu.filter(val);
    },
  },

  created() {
    this.userId = this.$route.query.userId;
    this.handleQuery();
  },

  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    async handleQuery() {
      this.loading = true;
      let param = { userId: this.userId };
      const response = await selectList(param).then();
      this.treeData = response.data.treeData;
      this.defaultCheckedKeys = response.data.defaultCheckedKeys;
      this.userCode = response.data.userCode;
      this.loading = false;
    },
    async save() {
      const checkedNodes = this.$refs.treeMenu.getCheckedNodes();

      const params = [];
      // console.log(JSON.stringify(checkedNodes))
      for (let i = 0; i < checkedNodes.length; i++) {
        if (checkedNodes[i].children.length == 0) {
          const param = {
            userId: this.userId,
            moduleId: checkedNodes[i].moduleId,
          };
          params.push(param);
        }
      }

      if (checkedNodes == '') {
        const param = {
          userId: this.userId,
          moduleId: 0,
        };
        params.push(param);
      }

      await add(params).then();
      this.msgSuccess('保存成功');
      await this.handleQuery();
    },
  },
};
</script>

<style scoped lang="scss">
.el-tabs {
  padding: 0 10px;
  height: 100%;
  .el-tab-pane {
    height: calc(100% - 75px);
  }
}
.elButtonSearch {
  background: #00b741;
  border: 1px solid #00b741;

  &:hover {
    background: #39d636;
    border: 1px solid #39d636;
  }
}

.searchListInput {
  .el-input__inner {
    &::placeholder {
      color: #838689;
    }
  }

  .el-date-editor .el-range-input {
    &::placeholder {
      color: #838689;
    }
  }

  .el-form-item {
    margin-bottom: 0.25rem;
  }
}
</style>
